<script lang="ts" setup>
import SearchField from "@/components/inputs/SearchField.vue";
import { useValidation } from "@/composables/useValidation";
import { stateShortMask } from "@/constants/mask";

const model = defineModel<string>({ default: "" });

const { stateValidator } = useValidation();

const emits = defineEmits<{
  (e: "search"): void;
}>();

withDefaults(
  defineProps<{
    label?: string;
  }>(),
  {
    label: "State",
  },
);
</script>

<template>
  <search-field
    id="search--state-field"
    v-model="model"
    :label="label"
    :mask="stateShortMask"
    :rules="[stateValidator]"
    @search="emits('search')"
  />
</template>
